import styled from 'styled-components';

export const DownloadReviewMain = styled.div`
    width: 100%;
    padding: 30px;
    background: #FFFFFF;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 15px;
    border-radius: 15px;
    box-shadow: 0px 10px 10px #0000000D; 
     @media screen and (max-width:767px) {
         flex-wrap: wrap;
         padding: 20px;
     } 
`;

export const DownloadReviewBox = styled.div`
    width: 100%;
    max-width: 455px;
    display: flex;
    flex-direction: column;
    color: #000000;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 26px;
   
    .btn-outline-success-blue{
        max-width: 182px;
        padding: 12px 20px;
    }
`;
export const BoxTitle = styled.h3`
    max-width: 222px;
    color: #333333;
    font-size: 30px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 44px; 
    margin-bottom: 20px;
  @media screen and (max-width:575px) {
       font-size: 25px;
        line-height: 30px;
        margin-bottom: 15px;
  }


`;
export const BoxText = styled.p`
    margin-bottom: 30px;
`;

export const BadgeWebsiteWrap = styled.div`
    width: 100%;
    max-width: 670px;
    padding: 20px 26px;
    background: #F3F3F3;
    border-radius: 20px;
    color: #000000;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 26px;
   @media screen and (max-width:575px) {
      margin-top:20px;   
   }
    .base-color{
        display: block;
        
        label{
            color: #F7931E;
            position: relative;
            
            &:before{
                content: '';
                width: 20px;
                height: 20px;
                border-radius: 10px;
                position: absolute;
                border: 1px solid #000;
                left: -27px;
                top: 1px;
                z-index: -1;
            }
        }
        .orange{
            .form-check-input{
                background: transparent;
                border: 1px solid #000;
            }
        }

        .green{
            .form-check-input{
                background: transparent;
                border: 1px solid #000;
            }
            label{
                color: #34A853;
            } 
        }

        .gray{
            label{
                color: #BABABA;
            } 
            .form-check-input{
                background: transparent;
                border: 1px solid #000;
            }
        }

        .blue{
            label{
                color: #33A7AE;
            } 
            .form-check-input{
                background: transparent;
                border: 1px solid #333333;
            }
        }

        .form-check-input{
            width: 20px;
            height: 20px;
            border-radius: 50%;
            position: relative;
            z-index: 2;
        
            &:checked {
            
                + label{
                    &:after{
                        content: '';
                        width: 10px;
                        height: 10px;
                        background: #333333;
                        border-radius: 10px;
                        position: absolute;
                        left: -22px;
                        top: 54%;
                        bottom: 0;
                        transform: translateY(-50%);
                    }
                }
            }
        
              &:focus{
                outline: 0;
                box-shadow: none;
              }
            
          }
    }
  .badge-color-box-radio {
    @media screen and (max-width:575px) {
         flex-wrap: wrap;
    }
  }
`;

export const BadgeWebsiteTitle = styled.h4`
    color: #000000;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 26px;
    margin-bottom: 20px;
`;

export const BadgeWebsiteText = styled.p`
    margin-bottom: 21px;
`;

export const BadgeWebsiteCheckBoxWrap = styled.div`
    width: 100%;
`;

export const DownloadScriptCodeWrap = styled.section`
    padding-top: 60px;
    background: #DDF5F6;
    @media screen and (max-width:575px) {
     padding-top: 30px;
     }
;`;


export const MiniBadgeSection = styled.section`
    margin-top: 60px;
    color: #333333;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 26px;
   @media screen and (max-width:575px) {
       font-size: 16px;
    }
`;
export const MiniBadgeTitle = styled.h2`
    color: #333333;
    font-size: 30px;
    font-family: 'Jost', sans-serif;
    font-weight: 600;
    line-height: 44px;
    @media screen and (max-width:575px) {
     font-size: 25px;
     line-height: 35px;
    }
`;

export const MiniBadgeText = styled.p`
    margin:20px 0px 10px;
`;


export const MiniBadgeWrap = styled.div`
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    column-gap: 23px;

 
    @media screen and (max-width:767px) {
           flex-wrap: wrap;
           gap: 20px;
       }
         .mini_badge-iframe{
             @media screen and (max-width:991px) {
                 height: 170px;
             }
         }  
`;

export const MiniBadgeCodeBox = styled.div`
    width: 100%;
    max-width: 385px;
    background: #FFFFFF;
    border-radius: 10px;
    padding: 20px;
     @media screen and (max-width:575px) {
        max-width: inherit;
     }
`;

export const MiniBadgeCodeCopyBox = styled.div`
    background: #FFFFFF;
    padding: 25px;
    width: 100%;
    max-width: 792px;
    border-radius: 20px;
    box-shadow: 0px 20px 20px #0000001A;
     word-wrap: break-word;
     @media screen and (max-width:991px) {
           word-wrap: break-word;
           max-width:inherit;
     }
     @media screen and (max-width:575px) {
           max-width:inherit;
     }
`;

export const ReviewImageBox = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 15px;
   
`;

export const ImageBox = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const ReviewImageTitle = styled.h4`
    color: #01606F;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 500;
    line-height: 22px;
`;

export const ReviewFromBox = styled.div`
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 15px;
    border-bottom: 1px solid #c6c3c3;
    padding: 12px 0;
    color: #c6c3c3;
    font-size: 20px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 24px;

    img{
        width: 100%;
        height: 100%;
        max-width: 200px;
        display: block;
    }
`;

export const ReviewFromText = styled.div`

`;

export const RecentReviewWrap = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 30px auto;
    color: #c6c3c3;
    font-size: 24px;
    font-family: 'Jost', sans-serif;
    font-weight: 500;
    line-height: 30px;
`;

export const RecentButton = styled.a`
    color: #01606F;
    font-size: 22px;
    font-family: 'Jost', sans-serif;
    font-weight: 600;
    line-height: 30px;
    margin-top: 15px;   
`;

export const SectionTitle = styled.div``;

export const Title = styled.h1`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size: 40px;
    font-weight: bold;
    line-height: 58px;
    margin-bottom: 30px;
     @media screen and (max-width:1199px) {
      font-size: 35px;
      line-height: 40px;
  }
  @media screen and (max-width:991px) {
      font-size: 30px;
      line-height: 35px;
  }
  @media screen and (max-width:575px) {
      font-size: 28px;
      line-height: 40px;
      margin-bottom: 20px;
  }
`;